export default __webpack_public_path__ + "static/twitter-8728658aa6717144118bdca781b71b47.jpg";